import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/Index.vue'
import store from '@/store'
import { canAccessRoute, getDefaultRoute } from '@/utils/permission'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('@/views/login/Agreement.vue'),
    meta: { title: '用户协议' , hidden: true}
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/Index.vue'),
        meta: { title: '仪表盘', icon: 'el-icon-s-platform' }
      }
    ]
  },
  {
    path: '/cloud',
    component: Layout,
    redirect: '/cloud/server',
    meta: { title: '云主机', icon: 'el-icon-monitor' },
    children: [
      {
        path: 'server',
        name: 'CloudServer',
        component: () => import('@/views/cloud/Server.vue'),
        meta: { title: '云服务器', icon: 'el-icon-monitor' }
      },
      {
        path: 'server/create',
        name: 'CreateServer',
        component: () => import('@/views/cloud/CreateServer.vue'),
        meta: { title: '创建云服务器', hidden: true }
      },
      {
        path: 'server/detail/:id',
        name: 'ServerDetail',
        component: () => import('@/views/cloud/ServerDetail.vue'),
        meta: { title: '服务器详情', hidden: true }
      }
    ]
  },
  {
    path: '/llm',
    component: Layout,
    redirect: '/llm/list',
    meta: { title: '大模型服务', icon: 'el-icon-cpu' },
    children: [
      {
        path: 'list',
        name: 'LlmList',
        component: () => import('@/views/llm/List.vue'),
        meta: { title: '我的模型', icon: 'el-icon-cpu' }
      },
      {
        path: 'detail/:id',
        name: 'LlmDetail',
        component: () => import('@/views/llm/Detail.vue'),
        meta: { title: '模型详情', hidden: true }
      }
    ]
  },
  {
    path: '/storage',
    component: Layout,
    redirect: '/storage/object',
    meta: { title: '云存储', icon: 'el-icon-folder-opened' },
    children: [
      {
        path: 'object',
        name: 'ObjectStorage',
        component: () => import('@/views/storage/Object.vue'),
        meta: { title: '对象存储', icon: 'el-icon-folder-opened' }
      },
      {
        path: 'bucket/:name',
        name: 'BucketDetail',
        component: () => import('@/views/storage/BucketDetail.vue'),
        meta: { title: 'Bucket详情', hidden: true }
      }
    ]
  },
  {
    path: '/database',
    component: Layout,
    redirect: '/database/list',
    meta: { title: '云数据库', icon: 'el-icon-coin' },
    children: [
      {
        path: 'list',
        name: 'DatabaseList',
        component: () => import('@/views/database/List.vue'),
        meta: { title: '数据库实例', icon: 'el-icon-coin' }
      },
      {
        path: 'create',
        name: 'CreateDatabase',
        component: () => import('@/views/database/Create.vue'),
        meta: { title: '创建数据库', hidden: true }
      },
      {
        path: 'detail/:id',
        name: 'DatabaseDetail',
        component: () => import('@/views/database/Detail.vue'),
        meta: { title: '数据库详情', hidden: true }
      }
    ]
  },
  {
    path: '/network',
    component: Layout,
    redirect: '/network/vpc',
    meta: { title: '网络管理', icon: 'el-icon-share' },
    children: [
      {
        path: 'vpc',
        name: 'VPC',
        component: () => import('@/views/network/VPC.vue'),
        meta: { title: '私有网络', icon: 'el-icon-share' }
      },
      {
        path: 'loadbalancer',
        name: 'LoadBalancer',
        component: () => import('@/views/network/LoadBalancer.vue'),
        meta: { title: '负载均衡', icon: 'el-icon-coordinate' }
      },
      {
        path: 'security-group',
        name: 'SecurityGroup',
        component: () => import('@/views/network/SecurityGroup.vue'),
        meta: { title: '安全组', icon: 'el-icon-lock' }
      }
    ]
  },
  {
    path: '/monitor',
    component: Layout,
    redirect: '/monitor/resource',
    meta: { title: '监控告警', icon: 'el-icon-warning' },
    children: [
      {
        path: 'resource',
        name: 'ResourceMonitor',
        component: () => import('@/views/monitor/Resource.vue'),
        meta: { title: '资源监控', icon: 'el-icon-data-line' }
      },
      {
        path: 'alarm',
        name: 'AlarmManage',
        component: () => import('@/views/monitor/Alarm.vue'),
        meta: { title: '告警管理', icon: 'el-icon-bell' }
      }
    ]
  },
  {
    path: '/billing',
    component: Layout,
    redirect: '/billing/overview',
    meta: { title: '账单管理', icon: 'el-icon-wallet' },
    children: [
      {
        path: 'overview',
        name: 'BillingOverview',
        component: () => import('@/views/billing/Overview.vue'),
        meta: { title: '费用总览', icon: 'el-icon-wallet' }
      },
      {
        path: 'detail',
        name: 'BillingDetail',
        component: () => import('@/views/billing/Detail.vue'),
        meta: { title: '账单明细', icon: 'el-icon-tickets' }
      },
      {
        path: 'recharge',
        name: 'RechargeHistory',
        component: () => import('@/views/billing/Recharge.vue'),
        meta: { title: '充值记录', icon: 'el-icon-bank-card' }
      },
      {
        path: 'invoice',
        name: 'InvoiceManage',
        component: () => import('@/views/billing/Invoice.vue'),
        meta: { title: '发票管理', icon: 'el-icon-document' }
      },
      {
        path: 'analysis',
        name: 'CostAnalysis',
        component: () => import('@/views/billing/Analysis.vue'),
        meta: { title: '消费分析', icon: 'el-icon-data-analysis' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/list',
    meta: { title: '用户管理', icon: 'el-icon-user' },
    children: [
      {
        path: 'list',
        name: 'UserList',
        component: () => import('@/views/user/List.vue'),
        meta: { title: '用户列表', icon: 'el-icon-user' }
      },
      {
        path: 'role',
        name: 'RoleManage',
        component: () => import('@/views/user/Role.vue'),
        meta: { title: '角色管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'profile',
        name: 'UserProfile',
        component: () => import('@/views/user/Profile.vue'),
        meta: { title: '个人中心', hidden: true }
      }
    ]
  },
  {
    path: '/settings',
    component: Layout,
    redirect: '/settings/system',
    meta: { title: '系统设置', icon: 'el-icon-setting' },
    children: [
      {
        path: 'system',
        name: 'SystemSettings',
        component: () => import('@/views/settings/System.vue'),
        meta: { title: '系统配置', icon: 'el-icon-setting' }
      }
    ]
  },
  {
    path: '/help',
    component: Layout,
    redirect: '/help/center',
    meta: { title: '帮助中心', icon: 'el-icon-question', hidden: true },
    children: [
      {
        path: 'center',
        name: 'HelpCenter',
        component: () => import('@/views/help/Center.vue'),
        meta: { title: '帮助中心', icon: 'el-icon-document' }
      },
      {
        path: 'contact',
        name: 'ContactUs',
        component: () => import('@/views/help/Contact.vue'),
        meta: { title: '联系我们', icon: 'el-icon-phone' }
      },
      {
        path: 'feedback',
        name: 'Feedback',
        component: () => import('@/views/help/Feedback.vue'),
        meta: { title: '意见反馈', icon: 'el-icon-edit' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = store.state.user.token
  const role = store.state.user.userInfo.role || 'admin'

  if (to.path === '/login' || to.path === '/agreement') {
    next()
    return
  }

  if (!token) {
    next('/login')
    return
  }

  if (to.path === '/' || to.path === '/dashboard') {
    if (role === 'customer') {
      next(getDefaultRoute(role))
      return
    }
  }

  if (canAccessRoute(to.path, role)) {
    next()
  } else {
    next(getDefaultRoute(role))
  }
})

export default router

